export const STATUS_ORDERS = 'STATUS_ORDERS'
export const FETCH_ORDERS = 'FETCH_ORDERS'
export const MESSAGE_ORDER = 'MESSAGE_ORDER'